import { resourceNameGameIdentity } from "motw_core/Entity/IGameIdentity";
import * as React from "react";
import ChevronPanel from "source/app/presentation/Shared/ChevronPanel/ChevronPanel";
import { FormInput } from "source/app/presentation/Shared/Form/Input/FormInput";
import Glyphicon from "source/app/presentation/Shared/Glyphicon/Glyphicon";
import { EGlyphicon } from "source/app/presentation/Shared/Glyphicon/EGlyphicon";
import Hyperlink from "source/app/presentation/Shared/Link/Hyperlink";
import Render from "source/app/presentation/Shared/Render";
import { Style } from "source/app/presentation/Shared/Styles/CSS";
import Data from "source/app/services/Data";
import ClientDataProvider from "source/app/services/External/ClientDataProvider/ClientDataProvider";
import { IGameIdentityDTO } from "../../../../../../../../motw_core/DTOs/IGameIdentityDTO";
import * as toastr from "toastr";
import { ShowIdentityDetails } from "../Details/ShowIdentityDetails";

export function EditMaxScore({
    identity,
    goalNamesLoggedToday,
}: {
    identity: IGameIdentityDTO;
    goalNamesLoggedToday: string[];
}) {
    if (identity.iscombo) {
        return null;
    }

    const [maxScore, setMaxScore] = React.useState(identity.maxscore);

    return (
        <div {...Style(`editMaxScoreContainer`, { position: `relative` })}>
            <ChevronPanel
                id="editMaxScoreChevronPanel"
                label="Change maximum score"
                dynamicOpacity={false}
            >
                <div>
                    <FormInput
                        label="Change max. score"
                        type="number"
                        width="50px"
                        onChange={(event) => {
                            setMaxScore(parseInt(event.target.value));
                        }}
                        value={maxScore}
                    />
                    <Hyperlink
                        whenClicked={async () =>
                            HandleMaxScoreChangeAsync(
                                identity,
                                goalNamesLoggedToday,
                                maxScore
                            )
                        }
                    >
                        <Render id="ok" when={maxScore !== identity.maxscore}>
                            <Glyphicon icon={EGlyphicon.ok} />
                        </Render>
                    </Hyperlink>
                </div>
            </ChevronPanel>
        </div>
    );
}

async function HandleMaxScoreChangeAsync(
    identity: IGameIdentityDTO,
    goalNamesLoggedToday: string[],
    maxscore: number
) {
    await ClientDataProvider.UpdateRecordAsync(
        `${resourceNameGameIdentity}?id=eq.${identity.id}`,
        { maxscore }
    );

    toastr.success(
        `Maximum score for the '${identity.name}' identity changed to ${maxscore}`
    );

    Data.Load.AllAsync();

    var newIdentity: IGameIdentityDTO = {
        ...identity,
        maxscore,
    };

    ShowIdentityDetails(newIdentity, goalNamesLoggedToday);
}
